import {
	SOFTWARE_PROJECT,
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	type ProjectType as ProjectTypeKey,
} from '@atlassian/jira-common-constants/src/project-types';
import type { User, Project, Category } from '@atlassian/jira-common-directory-v2/src/model';
import type {
	Project as RestProject,
	Category as RestCategory,
} from '@atlassian/jira-common-directory-v2/src/rest/types';
import type { User as RestUser } from '@atlassian/jira-shared-types/src/rest/jira/user.tsx';

const transformLead = (baseUrl: string, user?: RestUser): User | null =>
	user
		? {
				displayName: user.displayName,
				avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
				profileUrl: `/jira/people/${user.accountId}`,
				accountId: user.accountId,
			}
		: null;

const transformCategory = (category?: RestCategory): Category | undefined => {
	if (!category) {
		return undefined;
	}

	const { id, name, description } = category;
	return { id, name, description };
};

const transformProjectTypeKey = (typeKey?: string): ProjectTypeKey | undefined => {
	if (!typeKey) {
		return undefined;
	}

	if (typeKey === 'business') {
		return CORE_PROJECT;
	}
	if (typeKey === 'service_desk') {
		return SERVICE_DESK_PROJECT;
	}
	if (typeKey === 'software') {
		return SOFTWARE_PROJECT;
	}
	if (typeKey === 'product_discovery') {
		return PRODUCT_DISCOVERY_PROJECT;
	}

	return undefined;
};

export const transformProject = (item: RestProject, baseUrl: string): Project => {
	const {
		id,
		name,
		key,
		avatarUrls,
		projectTypeKey,
		favourite,
		isPrivate,
		simplified,
		lead,
		projectCategory,
		url,
		permissions,
		insight,
		landingPageInfo,
	} = item;

	return {
		id,
		key,
		name,
		avatarUrl: avatarUrls['48x48'],
		user: transformLead(baseUrl, lead),
		typeKey: transformProjectTypeKey(projectTypeKey),
		isFavourite: favourite,
		isPrivate,
		simplified,
		category: transformCategory(projectCategory),
		url,
		permissions,
		insight,
		landingPageInfo,
	};
};
